module.exports = __webpack_public_path__ + "img/tableau.1974d0d4.png";